import { BackednResponse } from "@shared/lib/types";
import {
  BriefNotificationStatusType,
  IBriefNotification,
} from "@shared/lib/types/brief";
import { useQuery } from "@tanstack/react-query";
import { BRIEF_NOTIFICATION_QUERY_KEY } from "../../constants";
import { BriefService } from "../../services/brief.service";

export default function usePollNotification(
  briefId: string,
  notificationId: string
) {
  const {
    data: notification,
    isFetching: isNotificationFetching,
    error: notificationError,
    isSuccess: isNotificationSuccess,
  } = useQuery<BackednResponse<IBriefNotification>>({
    queryKey: BRIEF_NOTIFICATION_QUERY_KEY(briefId, notificationId),
    queryFn: () => BriefService.getBriefNotification(briefId, notificationId),
    enabled: !!briefId && !!notificationId,
    refetchInterval: (query) => {
      const status = query?.state?.data?.data?.status;
      const shouldPoll =
        status === BriefNotificationStatusType.Pending ||
        status === BriefNotificationStatusType.Processing;
      return shouldPoll ? 3000 : undefined;
    },
    refetchIntervalInBackground: true,
    placeholderData: (prev) => prev,
  });

  return {
    notification: notification?.data,
    isFetching: isNotificationFetching,
    isError: notificationError,
    isSuccess: isNotificationSuccess,
  };
}
